import React, { useEffect, useState, useRef } from 'react';
import styles from './AdViseStep3.module.css';
import LazyLoad from 'react-lazyload';
import api from '../../../api'
import AutoCompleteInput from '../SubComponent/AutoCompleteInput';
import { openInstagramMedia } from '../../../util';

const AdViseStep3 = ({setAdViseStep, stepProps, setStepProps, marginTop}) => {
    const [showManualModal, setShowManualModal] = useState(false);
    const [manualInput, setManualInput] = useState('');
    const [excludeUsed, setExcludeUsed] = useState(true);

    const ScrollContainerRef = useRef(null);
    const hotpleRefs = useRef({});

    const whenHomeButtonClicked = () => {
        const back = window.confirm("선택한 정보들이 모두 초기화돼요.\n\n정말 첫 화면으로 돌아갈까요?");
        if(back)
            setAdViseStep(0)
    };

    const filteredHotples = () => {
        return stepProps[3].hotples
            .filter(hotple => (stepProps[3].category=='전체' || hotple.main_category == stepProps[3].category))
            .filter(hotple => (hotple.name && hotple.name.includes(stepProps[3].filterText)) || !hotple.name)
            .filter(hotple =>  !excludeUsed || !hotple.is_used);
    }

    const totalPages = Math.ceil(filteredHotples().length / 100);
	const currentHotplePage = filteredHotples().slice(stepProps[3].currentPage * 100, stepProps[3].currentPage * 100 + 100);

    function whenManualButtonClicked() {
        setManualInput('');        // 초기화
        setShowManualModal(true);  // 모달 열기
    }

    useEffect(() => {
        if(!(stepProps[3].hotples.length!=0 && stepProps[3].region == stepProps[1])){
            setStepProps(prev => {
                const newProps = [...prev];
                newProps[3] = {...newProps[3], hotple: null, hotples: [], category:'전체', currentPage:0};
                return newProps;
            });

            getHotThreshold();
            getRegionHotple();
        }
    }, []);

    useEffect(() => {
        if (stepProps[3].hotple && stepProps[3].hotples.length > 0) {
            setTimeout(() => {
                const targetElement = hotpleRefs.current[stepProps[3].hotple.hotple_id];
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 50); // 50ms 정도
        }
    }, [stepProps[3].hotples, stepProps[3].hotple]);

    useEffect(() => {
        if (ScrollContainerRef.current) {
            ScrollContainerRef.current.scrollTo({ top: 0, behavior: 'instant' });
        }
    }, [stepProps[3].currentPage]);

    const whenTopButtonClicked = () => {
        if (ScrollContainerRef.current) {
            ScrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    function whenHotpleClicked(hotple) {
        setStepProps(prev => {
            const newProps = [...prev];
            newProps[3] = {...newProps[3], hotple: hotple};
            return newProps;
        });
    }

    function whenCategoryClicked(category) {
        setStepProps(prev => {
            const newProps = [...prev];
            newProps[3] = {...newProps[3], hotple:null, category: category, currentPage:0, filterText:''};
            return newProps;
        });
    }

    function whenPageButtonClicked(page) {
        setStepProps(prev => {
            const newProps = [...prev];
            newProps[3] = {...newProps[3], hotple:null, currentPage:page, filterText:''};
            return newProps;
        });
    }

    const deleteFilterTextButtonClicked = () => {
		setStepProps(prev => {
            const newProps = [...prev];
            newProps[3] = {...newProps[3], hotple:null, filterText: '', currentPage:0};
            return newProps;
        });
	}

    const setFilterText = (text) => {
		setStepProps(prev => {
            const newProps = [...prev];
            newProps[3] = {...newProps[3], filterText: text, currentPage:0};
            return newProps;
        });
	}

    function getHotpleBadge(hotple) {
        const { start_date, end_date, mention_count, created_at, has_comment_event, uploaded_at } = hotple;
        
        if (has_comment_event && uploaded_at && (new Date(uploaded_at) >= new Date(Date.now() - 7 * 24 * 60 * 60 * 1000))) {
          return <div className={styles.periodBadge}>이벤트</div>;
        } 
        if (start_date && new Date(start_date) > new Date()) {
          return <div className={styles.endBadge}>시작예정</div>;
        } 
        if (end_date && new Date(end_date) < new Date()) {
          return <div className={styles.endBadge}>종료됨</div>;
        } 
        if (end_date && new Date(end_date) < new Date(Date.now() + 3 * 24 * 60 * 60 * 1000)) {
          return <div className={styles.periodBadge}>종료임박</div>;
        } 
        if (mention_count > stepProps[3].hotThreshold) {
          return <div className={styles.hotBadge}>HOT</div>;
        } 
        if (created_at && new Date(created_at) >= new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)) {
          return <div className={styles.newBadge}>NEW</div>;
        }
      
        return null; // 아무 배지도 해당 안 되면 null 반환
    }
    
    function whenNextButtonClicked() {
        if(stepProps[3].hotple){
            if(stepProps[3].hotple.naver_map_place_id)
                setAdViseStep(4);
            else{
                const confirm = window.confirm('네이버 장소 ID 정보가 없습니다. 관리자 화면으로 이동할까요?');
                if(confirm){
                    window.open(
                        `https://app.hotple.today?menu=admin&hotple_id=${stepProps[3].hotple.hotple_id}`,
                        '_blank'
                    )
                }
            }
        }
    }

    function extractPlaceIds(){
        const lines = manualInput
            .split(/\r?\n/)        // 개행으로 분리
            .map(l => l.trim())    // 앞뒤 공백 제거
            .filter(Boolean);      // 빈 줄 제거

        // place_id 추출
        const placeIds = Array.from(new Set(
            lines
            .map(line => {
                const m = line.match(/\/place\/(\d+)/);
                return m ? m[1] : null;
            })
            .filter(Boolean)
        ));

        return placeIds;
    }

    async function whenManualNextButtonClicked() {
        const placeIds = extractPlaceIds();

        if (placeIds.length === 0) {
            alert('유효한 네이버 지도 URL을 한 줄 이상 입력해주세요.');
            return;
        }

        if (placeIds.length === 1) {
            // 기존 1개 처리 로직
            const place_id = placeIds[0];
            setStepProps(prev => {
            const next = [...prev];
            next[3] = {
                ...next[3],
                hotple: { naver_map_place_id: place_id }
            };
            return next;
            });
            setAdViseStep(4);
        } else {
            try {
                const response = await api.post(
                    `/advise/admin/advise-hotples`,
                    {
                        placeIds: placeIds,
                        category: stepProps[3].category != '전체' ? stepProps[3].category : null
                    }
                );

                const count = response.data.hotpleIds.length;
                const queueLeft = response.data.queueLeft;

                if(count>0){
                    alert(`장소 ${count}개에 대한 분석을 요청 완료하여, 홈 화면으로 돌아갑니다.\n\n*각 장소들은 분석 완료 후 콘텐츠 제작이 가능합니다.\n*장소 분석은 순차적으로 진행되므로, 앞서 분석 요청 들어온 장소들이 많다면 분석 완료까지 시간이 꽤 소요될 수 있습니다.\n*앞선 분석 대기 장소 수: ${queueLeft}개`);
                    setAdViseStep(0);
                } else {
                    alert('이미 분석 완료된 장소들 입니다. 새로운 장소를 입력해주세요!');
                    return;
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        setShowManualModal(false);
    }

    function whenNaverMapButtonClicked(place_id) {
        const naverMapWebUrl = `https://m.place.naver.com/place/${place_id}/home`;
        window.open(naverMapWebUrl, '_blank');
    }

    function whenMediaButtonClicked(media_url) {
        openInstagramMedia(media_url);
    }

    async function whenDeleteButtonClicked(hotple) {
        console.log(hotple);
        const confirm = window.confirm(`AdVise.ai에서 등록한 '${hotple.name}'을 삭제할까요?`);
        if(confirm){
            try{
                const response = await api.delete(`/admin/hotple/${hotple.hotple_id}`);
                if (response.status === 200)
                    setStepProps(prev => {
                        const next = [...prev];
                        next[3] = {
                            ...next[3],
                            hotples: next[3].hotples.filter(h => h.hotple_id !== hotple.hotple_id)
                        };
                        return next;
                    });
                else
                    alert('장소 삭제에 실패했습니다.\n관리자에게 문의해주세요!');
            } catch(error) {
                alert('장소 삭제에 실패했습니다.\n관리자에게 문의해주세요!');
            }
        }
    }

    const getRegionHotple = async () => {
        try {
            const response = await api.get(`/advise/admin/hotple`,{
              params: {
                region: stepProps[1],
              }
            });

            setStepProps(prev => {
                const newProps = [...prev];
                newProps[3] = {...newProps[3], hotples: response.data.hotples, region: stepProps[1]};
                return newProps;
            });
          
        } catch (error) {
          console.error('Error fetching data:', error);
        }
    }

    const getHotThreshold = async () => {
        try {
            const response = await api.get(`/hotple/hot_threshold`);
            setStepProps(prev => {
                const newProps = [...prev];
                newProps[3] = {...newProps[3], hotThreshold: response.data.hotThreshold};
                return newProps;
            });
          
        } catch (error) {
          console.error('Error get HotThreshold:', error);
        }
    }

    return (
        <div className={styles.outerframe}>
            <div className={styles.upperframe}>
                <img className={styles.backbuttonIcon} alt="" src="images/back_android.svg" onClick={()=>setAdViseStep(2)}/>
                <div className={styles.titleframe}>
                    <b className={styles.nextbuttontext}>STEP 3</b>
                    <div className={styles.stepdesc}>어떤 핫플의 콘텐츠를 만들까요?</div>
                </div>
                <img className={styles.homebuttonIcon} alt="" src="images/home_outlined.svg" onClick={()=>whenHomeButtonClicked()}/>
            </div>
            <div className={styles.lowerframe} id="hotpleitems-container" style={{height:`calc(100dvh - ${marginTop}px - 103px - 74px)`}} ref={ScrollContainerRef}>
                <div className={styles.contentframe}>
                    <div className={styles.searchFrame}>
                        <AutoCompleteInput
                            filterText={stepProps[3].filterText}
                            setFilterText={setFilterText}
                            whenHotpleClicked={whenHotpleClicked}
                            suggestions={filteredHotples()}
                        />
                        {stepProps[3].filterText.length>0 &&
                            <div className={styles.div} onClick={deleteFilterTextButtonClicked}>
                                <img className={styles.iconsearch2} alt="" src="images/close_filled.svg" />
                            </div>
                        }
                    </div>
                    <div className={styles.categorybuttons}>
                        <div className={styles.div3}>
                            <div className={styles.list}>
                                <div className={`${stepProps[3].category === '전체' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('전체')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/star_filled.svg" />
                                    <div className={styles.label2}>전체</div>
                                </div>
                                <div className={`${stepProps[3].category === '음식점' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('음식점')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/restaurant.svg" />
                                    <div className={styles.label2}>음식점</div>
                                </div>
                                <div className={`${stepProps[3].category === '주점' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('주점')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/alcohol.svg" />
                                    <div className={styles.label2}>주점</div>
                                </div>
                                <div className={`${stepProps[3].category === '카페디저트' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('카페디저트')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/cafe.svg" />
                                    <div className={styles.label2}>카페/디저트</div>
                                </div>
                                <div className={`${stepProps[3].category === '오락액티비티' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('오락액티비티')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/activity.svg" />
                                    <div className={styles.label2}>오락/액티비티</div>
                                </div>
                                <div className={`${stepProps[3].category === '문화예술' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('문화예술')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/smile.svg" />
                                    <div className={styles.label2}>문화/예술</div>
                                </div>
                                <div className={`${stepProps[3].category === '팝업스토어' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('팝업스토어')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/popupStore.svg" />
                                    <div className={styles.label2}>팝업스토어</div>
                                </div>
                                <div className={`${stepProps[3].category === '휴식힐링' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('휴식힐링')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/flower.svg" />
                                    <div className={styles.label2}>휴식/힐링</div>
                                </div>
                                <div className={`${stepProps[3].category === '숙소' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('숙소')}>
                                    <img className={styles.iconstarFilled2} alt="" src="images/home_filled.svg" />
                                    <div className={styles.label2}>숙소</div>
                                </div>
                                <div className={styles.refresh} onClick={()=>{whenHotpleClicked(null);getRegionHotple();}}>🔃</div>
                                <label className={styles.excludeUsed}>
                                    이미 사용된 핫플 제외
                                    <input
                                        className={styles.checkbox}
                                        type="checkbox"
                                        checked={excludeUsed}
                                        onChange={() => setExcludeUsed(x => !x)}
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                    {totalPages > 0  && currentHotplePage.map((hotple, index) => (
                        <div key={index} className={(stepProps[3].hotple && stepProps[3].hotple.hotple_id == hotple.hotple_id) ? styles.hotpleItemFrameSelected : styles.hotpleItemFrame} onClick={()=>whenHotpleClicked(hotple)} ref={el => hotpleRefs.current[hotple.hotple_id] = el}>
                            {hotple.media_id && hotple.media_id[0].startsWith('A') &&
                                <div className={styles.iconcloseLineParent}>
                                    <img className={styles.iconcloseLine} onClick={(event)=> {event.stopPropagation(); whenDeleteButtonClicked(hotple);}} alt="" src="images/close_line.svg" />
                                </div>
                            }
                            {hotple.contents_url && hotple.contents_url.length>0 ?
                                <div className={styles.imageframe}>
                                    {hotple.contents_url[0] ?
                                        hotple.contents_url[0].includes("mp4") ?
                                            <div className={styles.image1frame} style={{marginLeft: '12px'}}>
                                                <LazyLoad height={152} offset={333} once scrollContainer="#hotpleitems-container">
                                                    <video
                                                        className={styles.image1Icon}
                                                        src={hotple.contents_url[0]}
                                                        poster={hotple.preview_url || "images/no_instagram_image.svg"}
                                                        controls
                                                        playsInline
                                                    />
                                                </LazyLoad>
                                            </div>
                                        :
                                            hotple.contents_url.map((url, index) => (
                                                <div key={index} className={index == 0 ? styles.image1frame : styles.image2frame} style={{marginLeft: index === 0 ? '12px' : 0}}>
                                                    <LazyLoad height={152} offset={333} once scrollContainer="#hotpleitems-container">
                                                        <img className={index == 0 ? styles.image1Icon : styles.image3Icon} alt="" src={url} />
                                                    </LazyLoad>
                                                </div>
                                            ))
                                    :
                                        <div className={styles.image2frame}/>
                                    }
                
                                    <div className={styles.image2frame} onClick={()=>openInstagramMedia(hotple.media_url)} style={{paddingRight: '12px'}}>
                                        <LazyLoad height={152} offset={333} once scrollContainer="#hotpleitems-container">
                                            <img className={styles.image2Icon} alt="" src={hotple.preview_url || "images/no_instagram_image.svg"} />
                                        </LazyLoad>
                                        {hotple.media_url &&
                                        <>
                                            <div className={styles.infoframe2}>
                                                {
                                                    hotple.media_id[0].startsWith('H') ?
                                                        <img className={styles.iconfire2} alt="" src="images/fire.svg" />
                                                    :
                                                        <img className={styles.iconinstagramColor} alt="" src="images/instagram.svg" />
                                                }
                                                <div className={styles.username}>@{hotple.media_creator}</div>
                                            </div>
                                            <div className={styles.infos}>
                                                <img className={styles.iconshare} alt="" src="images/share.svg" />
                                                <div className={styles.div}>
                                                    <span className={styles.txt}>
                                                            <p className={styles.p}>게시글</p>
                                                            <p className={styles.p}>보러가기</p>
                                                    </span>
                                                </div>
                                            </div>
                                        </>
                                        }
                                    </div>
                                </div>
                                :
                                <div/>
                            }
                            <div className={styles.analysisParentFrame}>
                                <div className={styles.analysisScrollFrame}>
                                    {hotple.key_features && hotple.key_features.length>0 && 
                                        <div className={styles.analysisFrame}>
                                            <div className={styles.padding1}/>
                                            <div className={styles.positive_text1}>
                                                ★{Math.floor(hotple.average_rating * 100) / 100}점
                                            </div>
                                            {hotple.key_features.map(item => (
                                                <div className={styles.positive_text0}>
                                                    {item}
                                                </div>
                                            ))}
                                            <div className={styles.padding1}/>
                                        </div>
                                    }
                
                                    {hotple.positive_summary && hotple.positive_summary.length>0 && 
                                        <div className={styles.analysisFrame}>
                                            <div className={styles.padding1}/>
                                            <div className={styles.positive_text}>
                                                긍정 {Math.floor(hotple.positive_ratio*100)}%
                                            </div>
                                            {hotple.positive_summary.map(item => (
                                                <div className={styles.positive_text0}>
                                                    "{item}"
                                                </div>
                                            ))}
                                            <div className={styles.padding1}/>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className={styles.detailframe}>
                                <div className={styles.detailleft}>
                                    <div className={styles.title}>
                                            <div className={styles.hotplename}>{hotple.name}</div>
                                            {getHotpleBadge(hotple) && <span className={styles.badgeWrapper}>{getHotpleBadge(hotple)}</span>}
                                            <div className={styles.ratingframe}>
                                                <img className={styles.iconfire} alt="" src="images/fire.svg" />
                                                <div className={styles.ratingtext}>{hotple.mention_count}명의 PICK!</div>
                                            </div>
                                    </div>
                                    <div className={styles.tags}>
                                            <div className={styles.tagplaceDetail}>
                                                <div className={styles.orange}>{hotple.main_category}</div>
                                            </div>
                                            <div className={styles.tagplaceDetail1}>
                                                <div className={styles.orange}>{hotple.sub_category1} ▸ {hotple.sub_category2}</div>
                                            </div>
                                            {hotple.tags && hotple.tags.slice(0, 3).map((tag, index) => (
                                                <div className={styles.tagplaceDetail2} key={index}>
                                                    <div className={styles.orange}>#{tag}</div>
                                                </div>
                                            ))}
                                    </div>
                                    <div className={styles.caption}>{hotple.caption}</div>
                                    {hotple.has_period &&
                                        <div className={styles.commentframe}>
                                                <div className={styles.label}>기간</div>
                                                <div className={styles.period}>{hotple.start_date && hotple.start_date.replaceAll('-','/')} ~ {hotple.end_date && hotple.end_date.replaceAll('-','/')}</div>
                                        </div>
                                    }
                                </div>
                                {(hotple.naver_map_place_id || hotple.media_url) &&
                                    <div className={styles.detailrightbutton}>
                                        {hotple.media_url &&
                                            <img className={hotple.media_url.includes('instagram.com') ? styles.iconlikeOutlined : styles.iconlikeOutlined2} alt="" src= {hotple.media_url.includes('instagram.com') ? "images/instagram_color.svg" : "images/internet.svg"} onClick={()=>whenMediaButtonClicked(hotple.media_url)}/>
                                        }
                                        {hotple.naver_map_place_id &&
                                            <img className={styles.iconlikeOutlined} alt="" src= "images/naver.svg" onClick={()=>whenNaverMapButtonClicked(hotple.naver_map_place_id)}/>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    ))}
                </div>
                {totalPages > 1 && (
                    <div className={styles.pagination}>
                        <div className={styles.pageButton} onClick={() => whenPageButtonClicked(Math.max(stepProps[3].currentPage - 1, 0))} disabled={stepProps[3].currentPage === 0}>
                            ◀
                        </div>
                        <div className={styles.pageIndex}>
                            {stepProps[3].currentPage + 1} / {totalPages}
                        </div>
                        <div className={styles.pageButton} onClick={() => whenPageButtonClicked(Math.min(stepProps[3].currentPage + 1, totalPages - 1))} disabled={stepProps[3].currentPage >= totalPages - 1}>
                            ▶
                        </div>
                    </div>
                )}
                <img className={styles.topButton} onClick={whenTopButtonClicked}  alt="" src="images/chevron_bottom.svg" />
            </div>
            <div className={styles.nextbuttonframe}>
                <div className={styles.backbutton2} onClick={()=>whenManualButtonClicked()}>
        				<div className={styles.nextbuttontext2}>네이버 URL로 진행</div>
      			</div>
                <div className={stepProps[3].hotple ? styles.nextbutton : styles.nextbuttonDisabled} onClick={()=>whenNextButtonClicked()}>
                    <b className={styles.nextbuttontext}>{stepProps[3].hotple ? "다음 →" : "핫플을 선택해주세요!"}</b>
                </div>
            </div>
            {showManualModal && (
                <div className={styles.overlay}>
                    <div className={styles.modal} onClick={e => e.stopPropagation()}>
                    <div className={styles.stepdesc}>네이버 장소 URL</div>
                    <div className={styles.categorybuttons}>
                        <div className={styles.div3}>
                            <div className={styles.list}>
                                <div className={`${stepProps[3].category === '전체' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('전체')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/star_filled.svg" />
                                    <div className={styles.label2}>AI 카테고리 결정</div>
                                </div>
                                <div className={`${stepProps[3].category === '음식점' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('음식점')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/restaurant.svg" />
                                    <div className={styles.label2}>음식점</div>
                                </div>
                                <div className={`${stepProps[3].category === '주점' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('주점')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/alcohol.svg" />
                                    <div className={styles.label2}>주점</div>
                                </div>
                                <div className={`${stepProps[3].category === '카페디저트' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('카페디저트')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/cafe.svg" />
                                    <div className={styles.label2}>카페/디저트</div>
                                </div>
                                <div className={`${stepProps[3].category === '오락액티비티' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('오락액티비티')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/activity.svg" />
                                    <div className={styles.label2}>오락/액티비티</div>
                                </div>
                                <div className={`${stepProps[3].category === '문화예술' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('문화예술')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/smile.svg" />
                                    <div className={styles.label2}>문화/예술</div>
                                </div>
                                <div className={`${stepProps[3].category === '휴식힐링' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('휴식힐링')}>
                                    <img className={styles.iconstarFilled} alt="" src="images/flower.svg" />
                                    <div className={styles.label2}>휴식/힐링</div>
                                </div>
                                <div className={`${stepProps[3].category === '숙소' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('숙소')}>
                                    <img className={styles.iconstarFilled2} alt="" src="images/home_filled.svg" />
                                    <div className={styles.label2}>숙소</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <textarea
                        className={styles.textarea}
                        rows={6}
                        value={manualInput}
                        onChange={e => setManualInput(e.target.value)}
                        placeholder="여러 장소 동시 입력 시 엔터로 구분!"
                    />
                    <div className={styles.modalButtons}>
                        <div className={styles.stepdesc2}>입력된 장소: {extractPlaceIds().length}개</div>
                        <button onClick={() => setShowManualModal(false)}>취소</button>
                        <button onClick={() => whenManualNextButtonClicked()}>확인</button>
                    </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AdViseStep3;